import { CoreProductArticleFilter } from './CoreProductArticleFilter';
import { CoreProductBrandFilter } from './CoreProductBrandFilter';
import { CoreProductBudgetLevelFilter } from './CoreProductBudgetLevelFilter';
import { CoreProductClassFilter } from './CoreProductClassFilter';
import { CoreProductCollectionTypeFilter } from './CoreProductCollectionTypeFilter';
import { CoreProductColorFilter } from './CoreProductColorFilter';
import { CoreProductCountBadge } from './CoreProductCountBadge';
import { CoreProductDepartmentFilter } from './CoreProductDepartmentFilter';
import { CoreProductEventFilter } from './CoreProductEventFilter';
import { CoreProductFilter } from './CoreProductFilter';
import { CoreProductGenderFilter } from './CoreProductGenderFilter';
import { CoreProductManufacturerFilter } from './CoreProductManufacturerFilter';
import { CoreProductMaterialFilter } from './CoreProductMaterialFilter';
import { CoreProductProductGroupsFilter } from './CoreProductProductGroupsFilter';
import { CoreProductSeasonEventFilter } from './CoreProductSeasonEventFilter';
import { CoreProductSeasonFilter } from './CoreProductSeasonFilter';
import { CoreProductSizeFilter } from './CoreProductSizeFilter';
import { CoreProductSizeRunFilter } from './CoreProductSizeRunFilter';
import { CoreProductSkuFilter } from './CoreProductSkuFilter';
import { CoreProductStyleFilter } from './CoreProductStyleFilter';
import { CoreProductSubClassFilter } from './CoreProductSubClassFilter';
import { CoreProductSubDepartmentFilter } from './CoreProductSubDepartmentFilter';

export const CoreProductGeneralFilters = {
  Product: CoreProductFilter,
  Article: CoreProductArticleFilter,
  BudgetLevel: CoreProductBudgetLevelFilter,
  Class: CoreProductClassFilter,
  Department: CoreProductDepartmentFilter,
  Season: CoreProductSeasonFilter,
  Event: CoreProductEventFilter,
  Brand: CoreProductBrandFilter,
  CollectionType: CoreProductCollectionTypeFilter,
  Manufacturer: CoreProductManufacturerFilter,
  SubClass: CoreProductSubClassFilter,
  SubDepartment: CoreProductSubDepartmentFilter,
  SeasonEvent: CoreProductSeasonEventFilter,
  ProductGroups: CoreProductProductGroupsFilter,
  Material: CoreProductMaterialFilter,
  Style: CoreProductStyleFilter,
  Color: CoreProductColorFilter,
  Gender: CoreProductGenderFilter,
  Sku: CoreProductSkuFilter,
  Size: CoreProductSizeFilter,
  SizeRun: CoreProductSizeRunFilter,
  CountBadge: CoreProductCountBadge,
};
